const dashOrUnderscoreAndFirstLetter = /([-_][a-z])/g;
const dashOrUnderscore = /[-_]/;

export const snakeCaseToCamelCase = (string: string): string =>
  string
    .toLowerCase()
    .replace(dashOrUnderscoreAndFirstLetter, (group) =>
      group.toUpperCase().replace(dashOrUnderscore, '')
    );
